import { ThemeContext } from "styled-components";

import { withContextFactory } from "../contexts/contexts.utils";
import { PropsWithTheme } from "../theme";


export const withTheme = withContextFactory<PropsWithTheme>(ThemeContext, "theme");
